import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordPencilIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 10">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m4.14 8.357 4.62-4.375c.768-.727.709-2.014-.13-2.84-.82-.805-2.07-.86-2.794-.123L1.342 5.606s.996.397 1.695 1.084S4.14 8.357 4.14 8.357"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="m.98 9.173 3.157-.812s-.402-.98-1.1-1.668c-.7-.688-1.695-1.085-1.695-1.085L.512 8.7c-.072.269.198.542.468.472"
      />
      <path
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m4.14 8.357 4.62-4.375c.768-.727.709-2.014-.13-2.84-.82-.805-2.07-.86-2.794-.123L1.342 5.606s.996.397 1.695 1.084S4.14 8.357 4.14 8.357"
        clipRule="evenodd"
      />
      <path
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m.98 9.173 3.157-.812s-.402-.98-1.1-1.668c-.7-.688-1.695-1.085-1.695-1.085L.512 8.7c-.072.269.198.542.468.472"
      />
    </svg>
  );
};

export default BordPencilIcon;
